import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Dialog, DialogActions, DialogContent, Link, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import AppBarModal from '../../general/AppBarModal';
import { BtnDetalle, BtnForm, BtnVer } from '../../general/BotonesAccion';
import ListarDatos from '../../general/ListarDatos';
import TareasTerminadas from '../../general/TareasTerminadas';
import emma_w from '../../../global/imagenes/emma_w.png';
import { api, consulta, generarFiltros } from '../../../global/js/funciones';

const obtenerUrlAdjunto = (ruta = '') => {
  if (!ruta) return '';
  if (ruta.startsWith('http')) return ruta;
  let path = ruta.startsWith('/media/') ? ruta : `/media/${ruta.replace(/^\/+/, '')}`;
  return `${api}${path}`;
};

function HistorialEmpresaDetalle({ historial }) {
  let {
    empresa,
    sucursal,
    contrato,
    tipoempresa,
    fecha_inicio,
    duracion,
    horario_entrada,
    horario_salida,
    auxilio,
    area_desarrollo,
    funciones,
    objetivo_practica,
    jefe,
    cargo_jefe,
    correo_jefe,
    telefono_jefe,
    adj_arl,
    fecha_registro,
  } = historial;

  let fechaFin = fecha_inicio && duracion ? moment(fecha_inicio).add(duracion, 'M').format('YYYY-MM-DD') : '';
  let fechaRegistro = fecha_registro ? moment(fecha_registro).format('YYYY-MM-DD, h:mm a') : 'No registra';
  let urlAdjunto = obtenerUrlAdjunto(adj_arl);

  return (
    <Table>
      <TableBody>
        <TableRow>
          <TableCell component="th" scope="row">Empresa</TableCell>
          <TableCell align="left">{empresa ? empresa.nombre : 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">NIT</TableCell>
          <TableCell align="left">{empresa ? empresa.codigo : 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Actividad Económica</TableCell>
          <TableCell align="left">{empresa ? empresa.descripcion : 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Sucursal</TableCell>
          <TableCell align="left">{sucursal ? sucursal.nombre : 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Ubicación</TableCell>
          <TableCell align="left">{sucursal ? sucursal.valora : 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Dirección</TableCell>
          <TableCell align="left">{sucursal ? sucursal.valorg : 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Barrio</TableCell>
          <TableCell align="left">{sucursal ? sucursal.valorb : 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Teléfono</TableCell>
          <TableCell align="left">{sucursal ? sucursal.valorc : 'No registra'}</TableCell>
        </TableRow>
        {tipoempresa && (
          <TableRow>
            <TableCell component="th" scope="row">Tipo de Empresa</TableCell>
            <TableCell align="left">{tipoempresa.nombre}</TableCell>
          </TableRow>
        )}
        {contrato && (
          <TableRow>
            <TableCell component="th" scope="row">Tipo de Contrato</TableCell>
            <TableCell align="left">{contrato.nombre}</TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell component="th" scope="row">Fecha Inicio</TableCell>
          <TableCell align="left">{fecha_inicio || 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Fecha Fin</TableCell>
          <TableCell align="left">{fechaFin || 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Duración</TableCell>
          <TableCell align="left">{duracion ? `${duracion} Meses` : 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Objetivo Practica</TableCell>
          <TableCell align="left">{objetivo_practica || 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Horario Entrada</TableCell>
          <TableCell align="left">{horario_entrada || 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Horario Salida</TableCell>
          <TableCell align="left">{horario_salida || 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">$Auxilio/Salario</TableCell>
          <TableCell align="left">{auxilio || auxilio === 0 ? auxilio : 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Area Desarrollo</TableCell>
          <TableCell align="left">{area_desarrollo || 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Funciones</TableCell>
          <TableCell align="left">{funciones || 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Jefe Inmediato</TableCell>
          <TableCell align="left">{jefe || 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Cargo Jefe</TableCell>
          <TableCell align="left">{cargo_jefe || 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Correo Jefe</TableCell>
          <TableCell align="left">{correo_jefe || 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Teléfono Jefe</TableCell>
          <TableCell align="left">{telefono_jefe || 'No registra'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Adjunto ARL</TableCell>
          <TableCell align="left">
            {urlAdjunto ? <Link href={urlAdjunto} target="_blank"><BtnVer callback={() => {}} texto='Ver' /></Link> : 'No registra'}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">Fecha Registro</TableCell>
          <TableCell align="left">{fechaRegistro}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}

HistorialEmpresaDetalle.propTypes = {
  historial: PropTypes.object.isRequired,
};

class PracticaHistorialEmpresas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cargando: true,
      historial: [],
      modalDetalle: false,
      cargandoDetalle: false,
      detalle: null,
    };
  }

  componentDidMount() {
    this.obtenerHistorial();
  }

  async obtenerHistorial() {
    let { practica_id } = this.props;
    this.setState({ cargando: true });
    let f = await generarFiltros([{ llave: 'practica', valor: practica_id }]);
    consulta(`api/v1.0/practicas/historial/empresa?${f}`, null, null, (error, estado, resp) => {
      this.setState({ historial: (!error && estado === 200) ? resp : [], cargando: false });
    });
  }

  obtenerDetalle = (id) => {
    this.setState({ modalDetalle: true, cargandoDetalle: true, detalle: null });
    consulta(`api/v1.0/practicas/historial/empresa/${id}`, null, null, (error, estado, resp) => {
      this.setState({ detalle: (!error && estado === 200) ? resp : null, cargandoDetalle: false });
    });
  }

  cerrarDetalle = () => {
    this.setState({ modalDetalle: false, cargandoDetalle: false, detalle: null });
  }

  acciones = (data) => {
    return <BtnDetalle callback={() => this.obtenerDetalle(data.id)} color='#01579b' texto='Abrir' />;
  }

  render() {
    let { cargando, historial, modalDetalle, cargandoDetalle, detalle } = this.state;

    if (cargando) return <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" />;

    return (
      <>
        <ListarDatos
          datos={historial}
          id='tbl_historial_empresa_practica'
          titulo='Lista Historial Empresas'
          buscar={false}
          opciones={true}
          acciones={(row) => this.acciones(row)}
          avatar={({ empresa }) => empresa && empresa.nombre ? empresa.nombre.charAt(0).toUpperCase() : 'H'}
          fila_principal={({ empresa }) => empresa ? empresa.nombre.toUpperCase() : 'EMPRESA NO REGISTRA'}
          filas={[
            {
              id: 'sucursal',
              nombre: 'Sucursal : ',
              mostrar: ({ sucursal }) => sucursal ? sucursal.nombre : 'No registra',
            },
            {
              id: 'fecha_inicio',
              nombre: 'Fecha Inicio : ',
              mostrar: ({ fecha_inicio }) => fecha_inicio || 'No registra',
            },
            {
              id: 'fecha_registro',
              nombre: 'Fecha Registro : ',
              mostrar: ({ fecha_registro }) => moment(fecha_registro).format('YYYY-MM-DD, h:mm a'),
            },
            {
              id: 'usuario_registro',
              nombre: 'Archivado por : ',
              mostrar: ({ usuario_registro }) => usuario_registro ? `${usuario_registro.primer_nombre} ${usuario_registro.primer_apellido} ${usuario_registro.segundo_apellido}` : 'No registra',
            },
          ]}
        />

        <Dialog open={modalDetalle} maxWidth='sm' fullWidth={true} onClose={this.cerrarDetalle}>
          <AppBarModal titulo='¡ Detalle Historial Empresa !' mostrarModal={this.cerrarDetalle} titulo_accion='' />
          <DialogContent style={{ padding: 0 }} className='scroll'>
            {cargandoDetalle ? (
              <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" />
            ) : (
              detalle && <HistorialEmpresaDetalle historial={detalle} />
            )}
          </DialogContent>
          <DialogActions>
            <BtnForm texto="CERRAR" callback={this.cerrarDetalle} />
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

PracticaHistorialEmpresas.propTypes = {
  practica_id: PropTypes.number.isRequired,
};

export default PracticaHistorialEmpresas;
